import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "fcon_triggers_wrap"
};
var _hoisted_2 = {
  key: 0,
  "class": "fc_trigger_map"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_trigger_map = _resolveComponent("trigger-map");
  var _component_trigger_adder = _resolveComponent("trigger-adder");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.trigger ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_trigger_map, {
    onUpdate: _cache[0] || (_cache[0] = function ($event) {
      return $options.triggerUpdate();
    }),
    trigger: $props.trigger,
    provider_info: $props.all_triggers[$props.trigger.trigger_provider]
  }, null, 8 /* PROPS */, ["trigger", "provider_info"])])) : _createCommentVNode("v-if", true), $data.show_adder ? (_openBlock(), _createBlock(_component_trigger_adder, {
    key: 1,
    onSuccess: $options.appendTrigger,
    integrations: $props.integrations,
    all_triggers: $props.all_triggers
  }, null, 8 /* PROPS */, ["onSuccess", "integrations", "all_triggers"])) : _createCommentVNode("v-if", true)]);
}